import { Grid, Typography } from "@mui/material";
import transformDateToDe from "../../../../functions/transformDateToDe";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";

const LastDay = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={6}
    sm={4}
    md={3}
    lg={3}
    sx={{
      mb: 2,
    }}
  >
    <Typography
      sx={{
        fontWeight: "bold",
      }}
      variant="caption"
      component="p"
    >
      Letzter Tag
    </Typography>
    <Typography variant="body1" component="p">
      {appointment.participantEndOfQualification !== null &&
        transformDateToDe(appointment.participantEndOfQualification)}
    </Typography>
  </Grid>
);

export default LastDay;
